module.exports = __webpack_public_path__ + "static/media/20ECE24.b22d1120.jpg";